import React from "react";

const Maps = () => {
  return (
    <React.Fragment>
        <div className="container">
        <iframe className="maps"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.737084280614!2d-58.46950788517722!3d-34.585518564041514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4446ceecd35151cf%3A0x9ac159df050f52ec!2sFratelli%20Control%20de%20Plagas!5e0!3m2!1ses!2sar!4v1645978850659!5m2!1ses!2sar"
       
        
        loading="lazy"
      ></iframe>
        </div>
      
    </React.Fragment>
  );
};

export default Maps;
